import { useState } from "react";
import { useIntl } from "react-intl";
import { useNavigate, useParams } from "react-router";
import AddVenue from "~Features/Venues/AddVenue";
import type { Venue } from "~types/venue";
import QuickLink from "./QuickLink";

const AddVenueLink = () => {
  const [isAddVenueModalOpen, setIsAddVenueModalOpen] = useState(false);
  const { formatMessage } = useIntl();
  const { customerId, sport, organizationId } = useParams();
  const navigate = useNavigate();
  const navigateToVenueDetailsPage = (venue: Venue) =>
    navigate(`/${customerId}/admin/${sport}/${organizationId}/venues/manage/${venue.venueId}`);

  return (
    <>
      <QuickLink
        title={formatMessage({ id: "venue.add.quickLink.title" })}
        description={formatMessage({ id: "venue.add.quickLink.description" })}
        handleClick={() => setIsAddVenueModalOpen(true)}
      />
      <AddVenue isModalOpen={isAddVenueModalOpen} handleClose={() => setIsAddVenueModalOpen(false)} onAdd={navigateToVenueDetailsPage} />
    </>
  );
};

export default AddVenueLink;
